export default __webpack_public_path__ + "8281faff4907fda9dd87f2a2436c9c56.svg";